module.exports = __webpack_public_path__ + "static/media/krx-trading-investor-03.f50a12f8.jpg";